import HttpService from "../HttpService";
import countries from "~/fc/Constants/countries";
import { getGCLIDFromLocal, getTelemetryUserIdFromLocal } from "../LTVTracker";

export async function getUserSubscription(token, all) {
  const params = all ? { all } : {};
  return await HttpService.payment()
    .setPath("/subscriptions")
    .setToken(token)
    .setParams(params)
    .get();
}

export async function getInvoices(token, page, offset) {
  return await HttpService.payment()
    .setPath("/invoices")
    .setToken(token)
    .setParams({ page, per_page: offset })
    .get();
}

export async function checkPaypalEligibility(token, plan) {
  const params = plan.type === "api" ? { price: plan.price.amount } : {};
  return await HttpService.payment()
    .setPath("/user/eligible-check/" + plan.id)
    .setParams(params)
    .setToken(token)
    .get();
}

// eslint-disable-next-line require-await
export async function getCountries() {
  return countries;
}

export async function getStripeRemoteSubscription(token, subscriptionId) {
  return await HttpService.payment()
    .setPath(`/subscriptions/remote/${subscriptionId}`)
    .setToken(token)
    .get();
}

export async function getPaymentIntent(token, paymentIntendId) {
  return await HttpService.payment()
    .setPath(`/charge/payment-intent/${paymentIntendId}`)
    .setToken(token)
    .get();
}

export async function stripeProration(
  token,
  customerId,
  planId,
  subscriptionId
) {
  const { data } = await HttpService.payment()
    .setPath(`/subscriptions/stripe-proration`)
    .setToken(token)
    .setBody({ customerId, planId, subscriptionId })
    .post();
  return data;
}

export async function fetchPlans(params, headers) {
  return HttpService.payment()
    .setPath("/plans")
    .setParams(params)
    .setHeaders(headers)
    .get();
}

/**
 * Creates a subscription entry for the user.
 * @param {*} params
 * @param {*} headers
 * @returns
 */
export async function createSubscription(token, payload) {
  const gclid = getGCLIDFromLocal();
  const telemetryUserId = getTelemetryUserIdFromLocal();
  
  // If gclid exists, include it in the payload
  if (gclid) {
    payload["gclid"] = gclid;
  }

  if (telemetryUserId) {
    payload["telemetryUserId"] = telemetryUserId;
  }

  return HttpService.payment()
    .setPath("/subscriptions")
    .setToken(token)
    .setBody(payload)
    .post();
}
